import { useEffect } from "react"
import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"
import Cookies from "js-cookie"

const DatalayerCalendlySubmit = props => {
  const datalayerCalendlyFormSubmitHandler = event => {
    const validClasses = ["cog-button--submit", "cog-button__text", "mktoButton"]
    
    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      const header = document?.querySelectorAll(".t2-layout-form__header") || document?.querySelectorAll(".formTopContent__header") || document.querySelectorAll(".cog-heading")
      const form_name = header.length > 0 ? header[0]?.innerText : null
      const formSection = props?.data?.contentfulPageGeneral?.sections?.find((element) => element?.formReference != null)
      const form_id = formSection?.formReference[0]?.formId
      window.dataLayer = window.dataLayer || []
      let data = {
        event: 'form_submit_success',
        form_name: form_name,
        previous_page: Cookies.get("prev_page") || window?.location?.href, //for contact sales when we lose the referrer
        form_company: document?.querySelector('input[name=Company]')?.value,
        form_country: document?.querySelector('select[name=CountryCode]')?.value,
        form_processing_consent: document?.querySelector('input[name=expressOptInSubmitted]')?.checked, //Boolean
        form_state: document?.querySelector('select[name=StateCode]')?.value,
        is_calendly: window?.Calendly !== undefined, //Boolean
        form_id: form_id,
        redirect_url: formSection?.formReference[0]?.followUpUrl,
      }
      // once the form gets submitted, save the necessary data in a cookie.
      Cookies.set("form_data", JSON?.stringify(data), { expires: new Date(new Date().getTime() + 15 * 60 * 1000) })
      
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = window?.Calendly !== undefined
  }
  useClickListener(datalayerCalendlyFormSubmitHandler, query)
  // after successful Calendly submission and redirect check if the cookie exists and matches the redirect location of the form. 
  // Take the data from the cookie, push to datalayer and delete cookie!
  useEffect(() => {
    if (Cookies.get("form_data") !== undefined) {
      const savedFormData = JSON?.parse(Cookies.get("form_data"))
      if (window?.location?.href?.includes(savedFormData?.redirect_url)) {
        window.dataLayer = window?.dataLayer || []
        window.dataLayer.push(savedFormData)
        Cookies.remove("form_data");
      }
    }
  }, [props?.pageContext?.slug])
}

export default DatalayerCalendlySubmit
